

import React, { memo, useContext } from 'react';

import EmptyDataPlaceholder from
'../../List/components/EmptyDataPlaceholder/containers/EmptyDataPlaceholder';
import DataTableGrid from './DataTableGrid';
import { DataTableContext } from '../context/dataTableContext';
import Loader from '../../Loader';
import { InfiniteScroll } from '../../InfiniteScroll';



const DataTableContentContainer = () => {
  const {
    hasData,
    isLoading,
    hasInfiniteScroll,
    infiniteScrollOptions,
    treeRowsNodes
  } = useContext(DataTableContext);

  if (isLoading) {
    return <Loader hasNoBeforeShowTimeout />;
  }

  if (hasData) {
    if (hasInfiniteScroll) {
      return (
        <InfiniteScroll
          {...infiniteScrollOptions}
          data={treeRowsNodes}>

          <DataTableGrid />
        </InfiniteScroll>);

    }

    return <DataTableGrid />;
  }

  return <EmptyDataPlaceholder />;
};

export default memo(DataTableContentContainer);